module.exports = __webpack_public_path__ + "t_workstyle_concierge_slide.png?d6f5649cff96aa2a618e035f3fe9040a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t_workstyle_concierge_slide.png
// module id = 847
// module chunks = 0